var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 150,
    viewBox: "0 0 382 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 74.8203C0 92.1088 14.0057 106.104 31.2909 106.104C48.5628 106.101 62.5749 92.1055 62.5749 74.8203C62.5749 57.5517 48.5628 43.543 31.2909 43.543C14.0024 43.543 0 57.5517 0 74.8203ZM70.6013 109.377C70.6013 131.526 88.5504 149.647 110.669 149.647L207.701 149.647C215.253 149.647 221.388 143.702 221.388 136.137C221.388 128.568 215.26 122.437 207.701 122.437L120.213 122.437V115.459C120.213 115.459 348.638 115.3 363.643 115.3C373.767 115.3 382 107.074 382 96.9355C382 86.8041 373.767 78.5947 363.643 78.5947L222.291 78.5947V71.0592L363.643 71.0592C373.767 71.0592 382 62.8498 382 52.6984C382 42.5604 373.767 34.278 363.643 34.278L120.213 34.278V27.2172L207.701 27.2172C215.253 27.2172 221.388 21.0759 221.388 13.5205C221.388 5.95181 215.26 -0.000259399 207.701 -0.000259399L110.669 -0.000259399C88.5504 -0.000259399 70.6013 18.1348 70.6013 40.2632L70.6013 109.377Z",
    fill: "#888B8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person2.780556d7.svg";
export { ForwardRef as ReactComponent };